import { render, staticRenderFns } from "./ClaimTable.vue?vue&type=template&id=e7d70540&scoped=true&lang=pug&"
import script from "./ClaimTable.vue?vue&type=script&lang=js&"
export * from "./ClaimTable.vue?vue&type=script&lang=js&"
import style0 from "./ClaimTable.vue?vue&type=style&index=0&id=e7d70540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d70540",
  null
  
)

export default component.exports